import {
    faUsers,
    faFileAlt,
    faUser,
    faDotCircle,
    faCalendar,
    faTimes,
    faBell,
    faBox,
    faChevronUp,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faDownload,
    faHistory,
    faEye,
    faHome,
    faSearch,
    faCheck,
    faBan,
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faAngleUp,
    faSort,
    faUserFriends,
    faIdCard,
    faEllipsisV,
    faEyeSlash,
    faCopy,
    faSave,
    faTruck,
    faPen,
    faCircleLeft,
    faCircleRight,    
    faBuilding
} from '@fortawesome/free-solid-svg-icons';

export const iconType = {
    Users: faUsers,
    User: faUser,
    File: faFileAlt,
    DotCircle: faDotCircle,
    Calendar: faCalendar,
    Close: faTimes,
    Bell: faBell,
    Box: faBox,
    ChevronUp: faChevronUp,
    ChevronDown: faChevronDown,
    ChevronLeft: faChevronLeft,
    ChevronRight: faChevronRight,
    Download: faDownload,
    History: faHistory,
    Eye: faEye,
    Home: faHome,
    Search: faSearch,
    Check: faCheck,
    Ban: faBan,
    AngleDown: faAngleDown,
    AngleLeft: faAngleLeft,
    AngleRight: faAngleRight,
    AngleUp: faAngleUp,
    Sort: faSort,
    UserFriends: faUserFriends,
    IdCard: faIdCard,
    EllipsisV: faEllipsisV,
    EyeSlash: faEyeSlash,
    Copy: faCopy,
    Save: faSave,
    Truck: faTruck,
    Pen: faPen,
    CircleLeft: faCircleLeft,
    CircleRight: faCircleRight,
    Store: faBuilding
};
